import clsx from "clsx";

export default function Input({
  id,
  label,
  placeholder,
  value,
  onChange,
  error = null,
  maxLength = 20,
  autoFocus = false,
  hideLabel = false,
}) {
  const errorId = `${id}-error`;

  return (
    <div className={clsx("input", error && "input--invalid")}>
      <label
        className={clsx(hideLabel ? "sr-only" : "input__label")}
        htmlFor={id}
      >
        {label}
      </label>
      <div className="input__control">
        <input
          className="input__field"
          id={id}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          maxLength={maxLength}
          autoFocus={autoFocus}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : undefined}
          required
        />
        {error ? (
          <p className="input__error" id={errorId}>
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
}
